export default __webpack_public_path__ + "static/media/runkeeper-interval-before-3.28b3a176.jpg";